import React from 'react';
import { useTranslation } from 'react-i18next';

interface OperationSettlementButtonModalSubmitButtonProps {
  testId?: string;
  className?: string;
}

export const OperationSettlementButtonModalSubmitButton: React.FC<
  OperationSettlementButtonModalSubmitButtonProps
> = ({ testId, className }) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`flex h-[36px] w-[90px] cursor-pointer items-center justify-center rounded-[5px] bg-[#FFD365] drop-shadow-3 ${className}`}
    >
      <span className="noto-13-medium w-[48px] text-center leading-[23px] opacity-[0.6]">
        {t('settlement.submit')}
      </span>
    </div>
  );
};
